import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import Svg from "./Svg";

const Icon = ({ name, className, ...props }) => (
  <div {...props} className={clsx("fill-current", className)}>
    <Svg name={name} />
  </div>
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
